module.exports = __webpack_public_path__ + "static/media/aws.b69541ba.png";